import React from 'react';
import { LanguageProvider } from '../../context/LanguageContext';
import FooterOne from '../../layout/Footer/FooterOne';
import Navbar from '../../layout/Header/Navbar';
import Layout from '../../layout/Layout';
import HeroFourteen from './HeroFourteen';
import ContactButton from '../../components/cta/ContactButton';
import SassMarketingIntregation from "../../components/sassMarketing/SassMarketingIntregation";
import CreativeAgencyTwoProduct from "../../components/creativeAgencyTwo/CreativeAgencyTwoProduct";
import TestimonialThree from '../../components/testimonial/TestimonialThree';
import CyberCta from "../../components/cta/CyberCta";
import FeatureFive from '../../components/features/FeatureFive';
import PageMeta from '../../components/common/PageMeta';

const HomeFourteen = () => {
  return (
    <LanguageProvider>
      <Layout>
        <PageMeta title="InfiniteDev" description="Desenvolvendo Sucesso" />
        <Navbar />
        <HeroFourteen />
        {/* <CustomerBrand /> */}
        {/* <DigiSerives /> */}
        {/* <CreativeAgencyTwoInfocard />
        <CreativeAgencyTwoInfocardNew /> */}
        <FeatureFive />
        <ContactButton />
        <SassMarketingIntregation />
        <CreativeAgencyTwoProduct />
        <TestimonialThree />
        <div style={{ 
          marginTop: '60px',  
          padding: '60px 0',
        }}>
          <CyberCta />
        </div>
        
        {/* <DigiWorkProcess /> */}
        {/* <DigiIntegration /> */}
        {/* <DigiBlog /> */}
        {/* <DigiContact /> */}
        <FooterOne
          style={{
            background:
              "url('assets/img/page-header-bg.svg')no-repeat bottom left",
          }}
        />
      </Layout>
    </LanguageProvider>
  );
};

export default HomeFourteen;
